import { render, staticRenderFns } from "./KeyFiguresBlock.vue?vue&type=template&id=21d183f9"
import script from "./KeyFiguresBlock.vue?vue&type=script&lang=js"
export * from "./KeyFiguresBlock.vue?vue&type=script&lang=js"
import style0 from "./KeyFiguresBlock.vue?vue&type=style&index=0&id=21d183f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports